import fgInput from './components/UIComponents/Inputs/formGroupInput.vue'
import DropDown from './components/UIComponents/Dropdown.vue'
// import RestaurantModal from './components/UIComponents/RestaurantModal.vue'
import UserModal from './components/UIComponents/UserModal.vue'
import OrderModal from './components/UIComponents/OrderModal.vue'
import Datepicker from './components/UIComponents/DatepickerPlugin/Datepicker.vue'
import Multiselect from 'vue-multiselect'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('fg-input', fgInput)
    Vue.component('drop-down', DropDown)
    // Vue.component('restaurant-modal', RestaurantModal)
    Vue.component('user-modal', UserModal)
    Vue.component('order-modal', OrderModal)
    Vue.component('datepicker', Datepicker)
    Vue.component('multiselect', Multiselect)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/gloablComponents.js